import { Logout, PersonOutline } from '@mui/icons-material';
import { List } from '@mui/material';
import { NavDrawerProps } from '@procureai/ui-mui';
import { useAuth } from 'react-oidc-context';

import { NavId, UserDomainType } from '~/common/types';
import { NavDrawerSimple } from '~/components/NavDrawerSimple/NavDrawerSimple';
import { NavSubListItemLink } from '~/components/NavSubListItemLink/NavSubListItemLink';

export const UserProfileDrawer = (props: NavDrawerProps) => {
  const { signoutRedirect } = useAuth();

  return (
    <NavDrawerSimple navId={NavId.userProfile} {...props}>
      <List sx={{ marginBottom: 4 }}>
        <NavSubListItemLink id={NavId.userProfile} selected Icon={PersonOutline} />
        <NavSubListItemLink
          id={UserDomainType.SIGN_OUT}
          onClick={() => {
            signoutRedirect();
          }}
          Icon={Logout}
        />
      </List>
    </NavDrawerSimple>
  );
};
